var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 0c.2 0 .4.098.6.196.5.295.6.885.3 1.377l-3.6 5.41 3.6 5.31c.3.492.2 1.082-.3 1.377-.5.295-1.1.197-1.4-.295l-4-5.901c-.2-.295-.2-.787 0-1.082l4-5.9c.2-.296.5-.493.8-.493Z",
    fill: "#51BB7B"
  })));
};
export default SvgArrowLeft;